import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import AdmStatusSistema from '../administrador/status-sistema';
import AdmSalas from '../administrador/salas';
import AdmGrupoLocal from '../administrador/grupo-local';
import AdmUsuarioLocal from '../administrador/usuario-local';
import AdmGerenciarGravacoes from '../administrador/gerenciar-gravacoes';
import AdmLogsAcesso from '../administrador/logs-acesso';

import OrgHome from '../organizador/home';
import OrgNovaSessao from '../organizador/nova-sessao';
import OrgEmAndamento from '../organizador/em-andamento';
import OrgAgendadas from '../organizador/agendadas';
import AgendadasFunctionalWrapper from '../organizador/agendadasFunctionalWrapper';
import OrgEncerradas from '../organizador/encerradas';

import PartHome from '../participante/home';
import PartAcessarSala from '../participante/acessar-sala';
import PartEmAndamento from '../participante/em-andamento';
import PartAgendadas from '../participante/agendadas';
import PartEncerradas from '../participante/encerradas';


import Acl from '../../utils/acl';

import { LayoutSplashScreen } from "../../../_metronic";


export default function HomePage() {
  
  let defaultRoute = ""
  if (Acl.can("administrador.status-sistema", true)) {
    defaultRoute = '/adm-status-sistema';
  } else if (Acl.can("organizador.nova-sessao", true)) {
    defaultRoute = "/org-nova-sessao";
  } else if (Acl.can("participante.em-andamento", true)) {
    defaultRoute = "/part-em-andamento";
  }

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
          {
          /* Redirect from root URL to /dashboard. */
            <Redirect exact from="/" to={defaultRoute} />
          }
            {Acl.can("administrador.status-sistema", <Route path="/adm-status-sistema" component={AdmStatusSistema} />)}
            {Acl.can("administrador.salas", <Route path="/adm-salas" component={AdmSalas} />)}
            {Acl.can("administrador.grupolocal", <Route path="/adm-grupo-local" component={AdmGrupoLocal} />)}
            {Acl.can("administrador.usuariolocal", <Route path="/adm-usuario-local" component={AdmUsuarioLocal} />)}
            {Acl.can("administrador.gerenciar-gravacoes", <Route path="/adm-gerenciar-gravacoes" component={AdmGerenciarGravacoes} />)}
            {Acl.can("administrador.logs-acesso", <Route path="/adm-logs-acesso" component={AdmLogsAcesso} />)}

            {/*{Acl.can("organizador.home", <Route path="/org-home" component={OrgHome} />)}*/}
            {Acl.can("organizador.nova-sessao", <Route path="/org-nova-sessao" component={OrgNovaSessao} />)}
            {Acl.can("organizador.gerenciar-sessoes.em-andamento", <Route path="/org-em-andamento" component={OrgEmAndamento} />)}
            {Acl.can("organizador.gerenciar-sessoes.agendadas", <Route path="/org-agendadas" component={AgendadasFunctionalWrapper} />)}
            {Acl.can("organizador.gerenciar-sessoes.encerradas", <Route path="/org-encerradas" component={OrgEncerradas} />)}

            {/*{Acl.can("participante.home", <Route path="/part-home" component={PartHome} />)}*/}
            {Acl.can("participante.em-andamento", <Route path="/part-em-andamento" component={PartEmAndamento} />)}
            {Acl.can("participante.em-andamento", <Route path="/:slug([0-9a-z]{1,20})" component={PartAcessarSala} />)}
            {Acl.can("participante.agendadas", <Route path="/part-agendadas" component={PartAgendadas} />)}
            {Acl.can("participante.encerradas", <Route path="/part-encerradas" component={PartEncerradas} />)}

          <Redirect to={defaultRoute + "/not-found"} />
        </Switch>
      </Suspense>
    );
  }